import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KnownPartnerId, PartnerId } from 'enums/PartnerName';
import { getApplicationData, hstreamCallback } from 'thunks';

import { GetApplicationDataResponse } from './applicationData';

export interface PreQualificationData {
  borrower_state_or_province?: string;
  loan_amount_passed?: boolean;
  loan_purpose?: string;
  credit_score_passed?: boolean;
  loan_term_in_months?: number;
  partnerId?: PartnerId;
  loan_goal?: string;
  benefit?: boolean;
  promoCode?: string;
}

const initialState: PreQualificationData = {
  loan_amount_passed: false,
  credit_score_passed: false,
  loan_term_in_months: 36,
};

const preQualificationData = createSlice({
  name: 'preQualification',
  initialState,
  reducers: {
    setStateData: (state: PreQualificationData, { payload }: PayloadAction<string | undefined>) => {
      state.borrower_state_or_province = payload;
      analytics.identify({ borrowerState: payload });
    },
    setLoanPurposeData: (state: PreQualificationData, { payload }: PayloadAction<PreQualificationData>) => {
      state.loan_purpose = payload.loan_purpose;
      analytics.identify({ loanPurpose: payload.loan_purpose });
    },
    setPartnerName: (state: PreQualificationData, { payload }: PayloadAction<PreQualificationData>) => {
      state.partnerId = payload.partnerId;
      typeof payload.benefit === 'boolean' && (state.benefit = payload.benefit);
    },
    setGoal: (state: PreQualificationData, { payload }: PayloadAction<string>) => {
      state.loan_goal = payload;
      analytics.identify({ loanGoal: payload });
    },
    setLoanAmountPassed: (state: PreQualificationData, { payload }: PayloadAction<boolean>) => {
      state.loan_amount_passed = payload;
    },
    setCreditScorePassed: (state: PreQualificationData, { payload }: PayloadAction<boolean>) => {
      state.credit_score_passed = payload;
    },
    setPromoCode: (state: PreQualificationData, { payload }: PayloadAction<string>) => {
      state.promoCode = payload;
      analytics.identify({ promoCode: payload });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getApplicationData.fulfilled, (state, { payload }: PayloadAction<GetApplicationDataResponse>) => {
      const { partnerId } = payload.application;
      if (partnerId) {
        state.partnerId = partnerId.toLowerCase() as PartnerId;
      }
    });
    builder.addCase(hstreamCallback.fulfilled, (state) => {
      // Set partnerId to HStream for authenticated users with hstream partner
      state.partnerId = KnownPartnerId.HStream;
    });
  },
});

export const {
  setStateData,
  setLoanPurposeData,
  setPartnerName,
  setLoanAmountPassed,
  setCreditScorePassed,
  setGoal,
  setPromoCode,
} = preQualificationData.actions;

export default preQualificationData.reducer;
